import { getAppraiserUIBaseUrl, getExternalDataroomBaseUrl } from 'ClientPortal/src/common/environment'

export function redirectToAppraiserUIHome() {
    window.location.replace(getAppraiserUIBaseUrl())
}

export function getExternalDataroomUrl(path: string) {
    return new URL(path, getExternalDataroomBaseUrl()).toString()
}

export function getExternalParticipantDataRoomUrl(orderId: string) {
    return getExternalDataroomUrl(`/external-participants/orders/${encodeURIComponent(orderId)}/data-room`)
}
